
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.818 1a.63.63 0 00-.636.625.63.63 0 00.636.625v.215c0 .828.336 1.623.932 2.209L5.098 6 3.75 7.326a3.098 3.098 0 00-.932 2.21v.214a.63.63 0 00-.636.625.63.63 0 00.636.625H9.18a.63.63 0 00.636-.625.63.63 0 00-.636-.625v-.215c0-.828-.336-1.623-.932-2.209L6.9 6l1.35-1.326c.596-.586.932-1.381.932-2.21V2.25a.63.63 0 00.636-.625A.63.63 0 009.182 1H2.818zM4.09 2.465V2.25h3.818v.215c0 .37-.112.73-.318 1.035H4.409a1.856 1.856 0 01-.319-1.035zM4.41 8.5c.07-.104.15-.201.24-.291L6 6.885l1.35 1.326c.091.09.17.187.242.291H4.41V8.5z","fill":"#0085FF"}})])
          )
        }
      }
    